import { render, staticRenderFns } from "./ForumVisitsAdmin.vue?vue&type=template&id=222b4561"
import script from "./ForumVisitsAdmin.vue?vue&type=script&lang=js"
export * from "./ForumVisitsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports